import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { CommunicationManagerService } from './communication-manager.service';
import { BankAccount } from '../models/bank-account';
import { Observable } from 'rxjs';
import { formatDate } from '@angular/common';
import { CreditCard, CreditCardFunds } from '../models/credit-card.model';

type CreditCardSave = Omit<
  CreditCard,
  | '_id'
  | 'createdAt'
  | 'currency'
  | 'cutOffDate'
  | 'company'
  | 'settlementDate'
  | 'deletedAt'
>;

@Injectable({
  providedIn: 'root',
})
export class CreditCardService {
  constructor(
    private cm: CommunicationManagerService,
    @Inject(LOCALE_ID) private locale: string
  ) {}

  getCreditCardsForCompany(companyId: string): Observable<Array<BankAccount>> {
    return this.cm.get(`creditCard/all`, [
      { headerName: 'companyId', headerValue: companyId },
    ]) as Observable<Array<BankAccount>>;
  }

  getReservedFundsForCompanyAndDate(
    companyId: string,
    date: Date
  ): Observable<Array<CreditCardFunds>> {
    const formattedDate = formatDate(date, 'YYYY-MM-dd', this.locale);

    return this.cm.get(`creditCard/balance/${formattedDate}`, [
      { headerName: 'companyId', headerValue: companyId },
    ]) as Observable<Array<CreditCardFunds>>;
  }

  createCreditCard(
    creditCard: CreditCardSave,
    companyId: string
  ): Observable<CreditCard> {
    return this.cm.postAndGetJson(`creditCard`, creditCard, [
      { headerName: 'companyId', headerValue: companyId },
    ]) as Observable<CreditCard>;
  }

  updateCreditCard(
    creditCard: CreditCard,
    creditCardId: string,
    companyId: string
  ): Observable<CreditCard> {
    return this.cm.put(`creditCard/${creditCardId}`, creditCard, [
      { headerName: 'companyId', headerValue: companyId },
    ]) as Observable<CreditCard>;
  }
}
